import { Severity } from 'constants/Severity';
import mitt from 'mitt';
import { NotificationResource } from 'models/Resources/NotificationResource';
import { StatusData } from 'store/Slices/Status/statusSlice';

type Events = {
  NOTIFICATION_EVENT: NotificationResource;
  STATUS_CHANGED_EVENT: StatusData;
  WEBSOCKET_CONNECTED_EVENT: string;
  WEBSOCKET_FAILED_EVENT: string;
  'ui:entrepot.changed': number;
  'ui:notification': { text: string; severity: Severity, duration?: number };
  'ui:notification.markAsRead': string;
};

export const emitter = mitt<Events>(); // inferred as Emitter<Events>

export const EntrepotChangedEvent = {
  publish:  (entrepot: number) => { emitter.emit('ui:entrepot.changed', entrepot)},
  subscribe: (fn: (entrepot: number) => void) => { emitter.on('ui:entrepot.changed', fn)}
}

export const NotificationMarkAsReadEvent = {
  publish:  (notificationId: string) => { emitter.emit('ui:notification.markAsRead', notificationId)},
  subscribe: (fn: (notificationId: string) => void) => { emitter.on('ui:notification.markAsRead', fn)}
}

export const NotificationEvent = {
  publish:  (notification: { text: string; severity: Severity, duration?: number }) => { emitter.emit('ui:notification', notification)},
  subscribe: (fn: (notification: { text: string; severity: Severity, duration?: number }) => void) => { emitter.on('ui:notification', fn)}
}

export const NotificationReceivedEvent = {
  publish:  (notification: NotificationResource) => { emitter.emit('NOTIFICATION_EVENT', notification)},
  subscribe: (fn: (notification:NotificationResource) => void) => { emitter.on('NOTIFICATION_EVENT', fn)}
}

export const StatusChangedReceivedEvent = {
  publish:  (statusData: StatusData) => { emitter.emit('STATUS_CHANGED_EVENT', statusData)},
  subscribe: (fn: (statusData:StatusData) => void) => { emitter.on('STATUS_CHANGED_EVENT', fn)}
}

export const WebsocketConnectedEvent = {
  publish:  (msg: string) => { emitter.emit('WEBSOCKET_CONNECTED_EVENT', msg)},
  subscribe: (fn: (msg:string) => void) => { emitter.on('WEBSOCKET_CONNECTED_EVENT', fn)}
}

export const WebsocketFailedEvent = {
  publish:  (msg: string) => { emitter.emit('WEBSOCKET_FAILED_EVENT', msg)},
  subscribe: (fn: (msg:string) => void) => { emitter.on('WEBSOCKET_FAILED_EVENT', fn)}
}
